<ng-container *ngIf="part$ | async as part">
  <pw-view-title>
    {{ part.TEXT }}
  </pw-view-title>

  <pw-view-actions>
    <button mat-icon-button (click)="openDrawer()">
      <mat-icon>filter_list</mat-icon>
    </button>
  </pw-view-actions>

  <pw-view-drawer>
    <div style="display: flex; flex-direction: column; gap: 1rem; padding: 1rem">
      <mat-slide-toggle [formControl]="onlyAssignedTasks">
        {{ 'planning.showTasks.myTasks' | translate }}
      </mat-slide-toggle>
      <mat-slide-toggle [formControl]="includeFinished">
        {{ 'planning.showTasks.includeFinished' | translate }}
      </mat-slide-toggle>
      <mat-slide-toggle [formControl]="includeUnplanned">
        {{ 'planning.showTasks.includeUnplanned' | translate }}
      </mat-slide-toggle>

      <button style="grid-column: auto / span 2; justify-self: end" mat-button
              (click)="currentViewService.drawer.toggle()"
              color="accent">{{ 'planning.showTasks.cancel' | translate }}
      </button>
    </div>
  </pw-view-drawer>

  <div class="mw-70" *ngIf="user$ | async as user">
    <mat-expansion-panel (expandedChange)="onExpanded($event)" [expanded]="expanded">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ (part$ | async)?.TEXT }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div style="display: grid; grid-template-columns: auto 1fr; gap: .5rem">
        <div style="font-weight: bold">{{ 'planning.showTasks.scannedObject' | translate }}:</div>
        <div>{{ (part$ | async)?.TEXT }}</div>
        <div style="font-weight: bold">{{ 'planning.showTasks.parentObject' | translate }}:</div>
        <div>{{ (parent$ | async)?.TEXT }}</div>
        <button [disabled]="Number((parent$ |async)?.OBJECT_ID) === 0"
                style="grid-column: auto / span 2; justify-self: end"
                mat-raised-button color="accent" routerLink="/planning/{{(parent$ | async)?.OBJECT_ID}}/tasks">
          {{ 'planning.showTasks.showParentObjects' | translate }}
        </button>
      </div>

    </mat-expansion-panel>

    <div style="padding-top: 1rem">
      <div [ngClass]="(isPhone$ | async) ? 'search-container-mobile' : 'search-container'">
        <mat-form-field>
          <input
            matInput
            placeholder="Filter"
            [formControl]="searchControl"/>
        </mat-form-field>
        <mat-chip-listbox>
          <mat-chip *ngIf="onlyAssignedTasks.value">
            {{ 'planning.showTasks.myTasks' | translate }}
            <button
              matChipRemove
              (click)="onlyAssignedTasks.setValue(false)">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip>
          <mat-chip *ngIf="includeFinished.value">
            {{ 'planning.showTasks.includeFinished' | translate }}
            <button
              matChipRemove
              (click)="includeFinished.setValue(false)">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip>
          <mat-chip *ngIf="includeUnplanned.value">
            {{ 'planning.showTasks.includeUnplanned' | translate }}
            <button
              matChipRemove
              (click)="includeUnplanned.setValue(false)">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip>
        </mat-chip-listbox>
      </div>
      <ng-container *ngIf="tasks$ | async as tasks">
        <div class="mat-elevation-z6" *ngIf="tasks.length > 0; else noTasks">
          <ng-container *ngFor="let task of tasks$ | async">
            <mat-divider></mat-divider>
            <p4m-mobile-task-component
              [task]="task"
              [user]="user"
              (onStartTracking)="startBooking($event)"
              [taskComponentConfig]="ppsService.getTaskComponentConfig()"
              [showResource]="true"
              (taskUpdated)="onTaskUpdated()"></p4m-mobile-task-component>
          </ng-container>
        </div>
      </ng-container>
    </div>

    <ng-template #noTasks>
      <div *ngIf="!(loadingService.isLoading | async); else loadingTasks">
        {{ 'planning.showTasks.noTasksFound' | translate }}
      </div>
    </ng-template>
    <ng-template #loadingTasks>
      <div>
        {{ 'planning.showTasks.loadingTasks' | translate }}
      </div>
    </ng-template>
  </div>
</ng-container>
